import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './par-type-identity.reducer';
import { IParTypeIdentity } from 'app/shared/model/par-type-identity.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ParTypeIdentity = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const parTypeIdentityList = useAppSelector(state => state.parTypeIdentity.entities);
  const loading = useAppSelector(state => state.parTypeIdentity.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="par-type-identity-heading" data-cy="ParTypeIdentityHeading">
        <Translate contentKey="almobadaraMasterDataApp.parTypeIdentity.home.title">Par Type Identities</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="almobadaraMasterDataApp.parTypeIdentity.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="almobadaraMasterDataApp.parTypeIdentity.home.createLabel">Create new Par Type Identity</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {parTypeIdentityList && parTypeIdentityList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parTypeIdentity.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parTypeIdentity.code">Code</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parTypeIdentity.name">Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parTypeIdentity.nameAr">Name Ar</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parTypeIdentity.nameEn">Name En</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parTypeIdentity.status">Status</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {parTypeIdentityList.map((parTypeIdentity, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${parTypeIdentity.id}`} color="link" size="sm">
                      {parTypeIdentity.id}
                    </Button>
                  </td>
                  <td>{parTypeIdentity.code}</td>
                  <td>{parTypeIdentity.name}</td>
                  <td>{parTypeIdentity.nameAr}</td>
                  <td>{parTypeIdentity.nameEn}</td>
                  <td>
                    <Translate contentKey={`almobadaraMasterDataApp.Status.${parTypeIdentity.status}`} />
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${parTypeIdentity.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${parTypeIdentity.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${parTypeIdentity.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Archive</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="almobadaraMasterDataApp.parTypeIdentity.home.notFound">No Par Type Identities found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ParTypeIdentity;
